import { render, staticRenderFns } from "./bitvalueType.vue?vue&type=template&id=1b83231b&scoped=true&"
import script from "./bitvalueType.vue?vue&type=script&lang=js&"
export * from "./bitvalueType.vue?vue&type=script&lang=js&"
import style0 from "./bitvalueType.vue?vue&type=style&index=0&id=1b83231b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b83231b",
  null
  
)

export default component.exports